<template>
  <div style="text-align: center">
  © 2019-2020
  <a href="https://devnullprod.com">
    Dev Null Productions LLC
  </a> |
  All Rights Reserved
  </div>
</template>

<script>
export default {
  name: 'MainFooter'
}
</script>

<style scoped>
div{
  font-size: 0.8rem;
  margin-bottom: 10px;
}

a{
  color: black;
}
</style>
